import React from 'react';
import { List, Datagrid, TextField, ReferenceField, DateField, required,AutocompleteInput ,
    EditButton, Edit, SimpleForm, TextInput, DateTimeInput, NumberInput,
    Create, ReferenceInput, Toolbar, DeleteButton, Filter, Pagination } from 'react-admin';


const CodePagination = props => <Pagination rowsPerPageOptions={[100, 50, 25, 10]} {...props} />;

    
const CodeFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Site Name" perPage = {10000}
        sort={{ field: 'name', order: 'ASC' }}
        source="site" reference="sites">
            <AutocompleteInput optionText="name" filterToQuery={searchText => ({ name: searchText })} />
        </ReferenceInput>
    </Filter>
);    
export const CodeList = props => (
    <List {...props} filters={<CodeFilter/>} pagination={<CodePagination />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="value" />
            <ReferenceField source="site" reference="sites" allowEmpty>
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField source="user" reference="users" allowEmpty>
                <TextField source="email" />
            </ReferenceField>
            <DateField source="expiration_ts" showTime/>
            <EditButton />
            <DeleteButton mutationMode={"pessimistic"} />
        </Datagrid>
    </List>
);

export const CodeEdit = props => (
    <Edit title={<CodeTitle />} {...props}>
        <SimpleForm toolbar={<Toolbar alwaysEnableSaveButton={true}/>}>
            <TextInput source="id" disabled />
            <TextInput source="value" validate={required()}/>
            <DateTimeInput source="expiration_ts"/>
            <ReferenceInput label="Site Name" perPage = {10000}
                sort={{ field: 'name', order: 'ASC' }}
                source="site" reference="sites">
            <AutocompleteInput optionText="name" filterToQuery={searchText => ({ name: searchText })} />
        </ReferenceInput>
        </SimpleForm>
    </Edit>
);


export const CodeCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput label={"Value (leave empty to generate)"} source="value" resettable />
            <ReferenceInput label="Site Name" perPage = {10000}
                sort={{ field: 'name', order: 'ASC' }}
                source="site" reference="sites">
            <AutocompleteInput optionText="name" filterToQuery={searchText => ({ name: searchText })} />
        </ReferenceInput>
            <NumberInput source="code_number" label={"Number of codes to create"} />
        </SimpleForm>
    </Create>
);

const CodeTitle = ({ record }) => {
         return <span>Code {record ? `"${record.value}"` : ''}</span>;
     };
    